export const PAYMENT_IBAN = 'SK9183300000002102931198';
export const PAYMENT_CREDITOR_NAME = 'Klubovňa';

export const PAYMENT_CONFIG = {
  CURRENCY: 'EUR',
  CONSTANT_SYMBOL: '0308',
  DEFAULT_MESSAGE: 'Dar',
} as const;
